import * as React from 'react'
import { Badge, badges } from '@amzn/dvui/dist/Badge'
import { AtfTreatmentProps } from '../../reducers/features'
import { isTreatment } from '../../utils/utils'
import * as badgeSt from './badge.module.scss'

export interface IDateTimeBadgeProps extends AtfTreatmentProps {
  dateTimeBadge?: string
}

export const DateTime = ({ dateTimeBadge, atfTreatment }: IDateTimeBadgeProps) => (
  dateTimeBadge &&
  (<Badge use={badges.TEXT} {...(isTreatment(atfTreatment,'T1', 'T2', 'T3') && { className: badgeSt.lightBadge})}>
    <span data-automation-id="date-time-badge">{dateTimeBadge}</span>
  </Badge>) || null
)
